import DataTable, { TableProps, TableStyles } from "react-data-table-component";

import { fontFamilyDefault } from "@/styles/typography";

// Internally, customStyles will deep merges your customStyles with the default styling.
const customStyles: TableStyles = {
  rows: {
    style: {
      backgroundColor: "#FEFAF1",
      "&:hover": {
        background: "#fff6e3",
        boxShadow: "5px 0px 5px rgba(0,0,0,0.2)",
        // boxShadow:
        //   " 0px 3px 1px -2px rgba(0, 0, 0, 0.2),0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)",
      },
      fontFamily: fontFamilyDefault,
      cursor: "pointer",
      padding: "5px",
    },
  },
  headRow: {
    style: {
      backgroundColor: "#FAF6F4",
      fontWeight: 400,
      fontSize: 12,
      lineHeight: "22px",
      fontFamily: fontFamilyDefault,
      textTransform: "uppercase",
    },
  },
  cells: {
    style: {
      fontWeight: 400,
      fontSize: 12,
      lineHeight: "22px",
      fontFamily: fontFamilyDefault,
    },
  },
  pagination: {
    style: {
      fontFamily: fontFamilyDefault,
    },
  },
};

export function StyledDataTable<T>(props: TableProps<T>) {
  return <DataTable customStyles={customStyles} {...props} />;
}
